import { useCallback } from 'react';

import useDetailModalStore, {
  type DETAIL_MODAL_TYPE,
} from '@/stores/pure/DetailModalStore';

type ChartDialogOptions =
  | ChartFeedbackListModalOptions<CellFeedbackListModalOptions>
  | ChartFeedbackListModalOptions<AllFeedbackListModalOptions>;

type ChartDialogParams = {
  alias: string;
  type: DETAIL_MODAL_TYPE;
  idx?: number;
  options: ChartDialogOptions;
  keys?: unknown[];
};

export const useOpenChartClickDialog = () => {
  const setNewModal = useDetailModalStore((state) => state.setNewModal);

  return useCallback(
    ({ alias, type, idx, options, keys }: ChartDialogParams) => {
      setNewModal({
        alias,
        type,
        idx,
        options,
        keys,
      });
    },
    [setNewModal],
  );
};
